import React from 'react';
import { View, Text, Image, TouchableOpacity } from 'react-native';
import StyleSheet from 'react-native-media-query';
import colors from '../../theme/Colors';
import size from '../../theme/Fonts';
import images from '../../theme/Images';
import { getScreenHeight, getScreenWidth } from '../../utils/LayoutUtility';

const SelfieResultEmptyState = ({
  removeAppliedFilter,
  buttonText = 'Clear filter',
  title = 'No Selfies found',
  subtitle = 'Try removing filter to get the results',
}) => {
  return (
    <View style={styles.container} dataSet={{ media: ids.container }}>
      <Image
        source={images.emptyFilterResults}
        style={styles.emptyStateImage}
        resizeMode={'contain'}
      />
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.subtitle}>{subtitle}</Text>

      <TouchableOpacity onPress={removeAppliedFilter}>
        <View style={styles.buttonContainer}>
          <Text style={styles.buttonText}>{buttonText}</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  container: {
    height: getScreenHeight(),
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    // bottom: 100,
    '@media (min-width: 768px)': {
      height: getScreenHeight() / 4.5,
      width: getScreenWidth(),
      alignSelf: 'center',
    },
  },
  emptyStateImage: {
    height: 95,
    width: 100,
  },
  title: {
    marginTop: 15,
    fontFamily: 'Roboto-Medium',
    fontSize: size.h3,
    color: colors.foxyBlack,
  },
  subtitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: size.h4,
    color: colors.subtitle,
    marginTop: 8,
  },
  buttonContainer: {
    width: 120,
    marginTop: 30,
    borderRadius: 16,
    backgroundColor: colors.black,
    padding: 7,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    fontFamily: 'Roboto-Medium',
    fontSize: size.h3,
    color: colors.white,
  },
});

export default SelfieResultEmptyState;
